import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: alertify.js",
  "description": "",
  "published": "2012-11-29T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-alertify-js/swizec/5614"],
  "categories": "Dialog box, HTML, JavaScript, JavaScript library, jQuery, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://fabien-d.github.com/alertify.js/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/11/alertify.js-1024x232.png",
          "alt": "alertify.js",
          "title": "alertify.js"
        }}></img></a></p>
    <p>{`Sometimes you come across a library so full of promise and amazingness that you have to write about it before even trying it out.`}</p>
    <p><a parentName="p" {...{
        "href": "http://fabien-d.github.com/alertify.js/"
      }}>{`Alertify.js`}</a>{` is a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript_library",
        "title": "JavaScript library"
      }}>{`javascript library`}</a>{` that brings `}<em parentName="p">{`alert()`}</em>{` and `}<em parentName="p">{`prompt()`}</em>{` into the web world of 2012. No longer will you be forced to use some arcane instruction full of ugly windows and so terribly un-new it sends chills down your spine just thinking about using it.`}</p>
    <p>{`Really ... was anyone still using that for anything other than debugging? Besides `}{`~`}{`~porn `}{`~`}{`~phishing sites I mean.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/old-alert.png",
        "alt": "The old alert()",
        "title": "The old alert()"
      }}></img></p>
    <p>{`The difference between old way and new is realy quite amazing. While a normal alert() creates a whole new window and blocks javascript execution, alertify's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Dialog_box",
        "title": "Dialog box"
      }}>{`alert box`}</a>{` is a lot easier on the eye, rolls nicely down from the top of the window and most of all `}<em parentName="p">{`is customisable.`}</em></p>
    <p>{`Although blocking execution would actually be kind of useful, alertify.js can fake this with careful use of callback soup and apparently manages to do something to at least prevent clicking on the page. So unless you get an event from a timer or a socket, you can rest assured nothing will happen while the alert is displayed.`}</p>
    <p>{`It also plays nice with us keyboard maniacs - you can use the `}<em parentName="p">{`ESC`}</em>{` key to make a Prompt or Confirm dialog go away.`}</p>
    <p>{`Another feature I really like are the logging facilities. It's a log you actually won't mind showing to your users! Wonderful.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/log-messages-1024x235.png",
        "alt": "Log messages",
        "title": "Log messages"
      }}></img></p>
    <p>{`Then again, for debugging I will probably still be using `}<em parentName="p">{`console.log`}</em>{` and ruining my sites for all `}<a parentName="p" {...{
        "href": "http://www.microsoft.com/windows/internet-explorer/",
        "title": "Internet Explorer"
      }}>{`Internet Explorer`}</a>{` users when I forget to remove debugging lines ... with alertify.js it's at least impossible to forget.`}</p>
    <p>{`Oh and another cool thing, Fabien Doiron implemented the whole thing without `}<a parentName="p" {...{
        "href": "http://jquery.com/",
        "title": "JQuery"
      }}>{`jQuery`}</a>{`, which I think is just impressive, these days I probably can't do anything without jQuery anymore ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.studentrnd.org/post/36041434495/tutorial-creating-a-reddit-browser-with-node-js-and"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_101_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.studentrnd.org/post/36041434495/tutorial-creating-a-reddit-browser-with-node-js-and"
        }}>{`Creating a Reddit Browser with Node.js and Twilio`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://magedfarag.wordpress.com/2012/11/28/graphics-and-animation-using-html5-canvas-libraries/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_103_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://magedfarag.wordpress.com/2012/11/28/graphics-and-animation-using-html5-canvas-libraries/"
        }}>{`Graphics and animation using HTML5 canvas libraries`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://greatfinds.icrossing.com/the-rise-of-javascript-micro-frameworks/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_109_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://greatfinds.icrossing.com/the-rise-of-javascript-micro-frameworks/"
        }}>{`The rise of JavaScript micro-frameworks`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://functionn.blogspot.com/2012/11/heyofflinejs-javascript-library-to-warn.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/127705588_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://functionn.blogspot.com/2012/11/heyofflinejs-javascript-library-to-warn.html"
        }}>{`Heyoffline.js - A JavaScript Library To Warn Users When Their Network Goes Down`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ce822fd5-0547-407b-a0b0-77aa60ea958f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      